export default __webpack_public_path__ + "static/media/Proposable.42ba08e2.png";